const translations = {
  de: {
    address: 'Adresse',
    'address-place-or-business': 'Adress, Ort or Geschäft',
    'add-via-button-label': 'Füge Zwischenziel hinzu',
    'add-via-duration-button-label': 'Set stop duration at via point {{index}}',
    'add-via-duration-button-label-close':
      'Close stop duration selector at via point {{index}}',
    'add-via-duration-button-label-open':
      'Open stop duration selector at via point {{index}}',
    airplane: 'Flug',
    arrival: 'Ankunft',
    back: 'Zurück',
    bikerentalstation: 'Leihrad-Station',
    bus: 'Bus',
    cancel: 'Abbrechen',
    'clear-button-label': 'Löschen',
    'clear-search-history': 'Suchhistorie löschen',
    currentposition: 'Aktuelle Position',
    delete: 'Löschen',
    'delete-old-searches-header': 'Wollen Sie die Such-Historie löschen?',
    departure: 'Abfahrt',
    destination: 'Ziel',
    'give-origin': 'Start eingeben.',
    'give-destination': 'Ziel eingeben.',
    favourite: 'Favoriten',
    ferry: 'Fähre',
    'future-route': 'Zukünftige Verbindung',
    origin: 'Start',
    'origin-stop-near-you': 'Start',
    ownlocations: 'Eigene Favoriten',
    loading: 'Laden...',
    'minute-short': 'min',
    rail: 'Zug',
    search: 'Suche',
    'search-address-or-place': 'Suche anhand von Adresse oder Ortsangabe',
    'search-button-label': 'Suche',
    'search-destination': 'Suche Zielort, Linie or Haltestelle',
    'search-destination-index': 'Zielort eingeben',
    'search-destination-results-but-no-search':
      'Ergebnisse in “Zielort”-Reiter anzeigen',
    'search-no-results': 'Kein Ort gefunden.',
    'search-origin': 'Suche Startort, Linie oder Haltestelle',
    'search-origin-index': 'Startort eingeben',
    'search-position': 'Standort ermitteln',
    'search-autosuggest-label': 'Venue, place and stopsearch.',
    'search-autosuggest-label-instructions-desktop':
      'Navigate list with arrow keys and select with enter key.',
    'search-autosuggest-label-instructions-mobile':
      'Enter the location and navigate in the list by swiping.',
    'search-autosuggest-label-move-to-destination':
      'After selecting the starting location you are automatically moved to the destination field.',
    'search-autosuggest-len': 'There is {{count}} suggestion available',
    'search-autosuggest-len_plural':
      'There are {{count}} suggestions available',
    'search-current-suggestion': 'Aktuelle Auswahl: {{selection}}',
    street: 'Straße',
    subway: 'U-Bahn',
    station: 'Station',
    stop: 'Haltestelle',
    'stop-near-you': 'Suche Haltestellen und Linien in der Nähe',
    'stop-near-you-bus': 'Suche Buslinien or Haltestellen',
    'stop-near-you-citybike': 'Suche Leihrad-Stationen',
    'stop-near-you-rail': 'Suche Zugverbindungen oder Bahnhöfe',
    'stop-near-you-subway': 'Suche U-Bahn-Linien oder Haltestellen',
    'stop-near-you-tram': 'Suche Stadtbahn-Haltestellen-Suche',
    'today-at': 'Heute um',
    'tomorrow-at': 'Morgen um',
    tram: 'Straßenbahn',
    'use-own-position': 'Benutze aktuellen Standort',
    'select-from-map': 'Wähle Position anhand Karte',
    'select-from-own-locations': 'Aus eigenen Favoriten auswählen',
    venue: 'Venue',
    'via-point': 'Zwischenziel',
    where: 'Wohin?',
    place: 'Ort',
  },
  en: {
    address: 'Address',
    'address-place-or-business': 'Address, place or business',
    'add-via-button-label': 'Add via point',
    'add-via-duration-button-label': 'Set stop duration at via point {{index}}',
    'add-via-duration-button-label-close':
      'Close stop duration selector at via point {{index}}',
    'add-via-duration-button-label-open':
      'Open stop duration selector at via point {{index}}',
    airplane: 'Flight',
    arrival: 'Arrival',
    back: 'Back',
    bikepark: 'Park & Ride for bikes',
    bikerentalstation: 'Bike station',
    bus: 'bus',
    cancel: 'Cancel',
    carpark: 'Park & Ride',
    'clear-button-label': 'Clear',
    'clear-search-history': 'Clear search history',
    currentposition: 'Current position',
    delete: 'Delete',
    'delete-old-searches-header': 'Do you want to clear the search history?',
    departure: 'Departure',
    destination: 'Destination',
    'give-origin': 'Enter your origin.',
    'give-destination': 'Enter your destination',
    favourite: 'Favourite',
    ferry: 'Ferry',
    'future-route': 'Future route',
    origin: 'Start',
    'origin-stop-near-you': 'Start',
    ownlocations: 'Own locations',
    loading: 'Loading...',
    'minute-short': 'm',
    platform: 'Platform',
    rail: 'Train',
    required: 'required field',
    search: 'Search',
    'search-address-or-place': 'Search by address or place name',
    'search-button-label': 'Search',
    'search-destination': 'Search destination, route or stop',
    'search-destination-index': 'Enter destination',
    'search-destination-results-but-no-search':
      'View results in the adjacent “Destination” tab',
    'search-no-results': 'No location',
    'search-origin': 'Search origin, route or stop',
    'search-origin-index': 'Enter origin',
    'search-position': 'Detect location',
    'search-autosuggest-label': 'Venue, place and stopsearch.',
    'search-autosuggest-label-instructions-desktop':
      'Navigate list with arrow keys and select with enter key.',
    'search-autosuggest-label-instructions-mobile':
      'Enter the location and navigate in the list by swiping.',
    'search-autosuggest-label-move-to-destination':
      'After selecting the starting location you are automatically moved to the destination field.',
    'search-autosuggest-len': 'There is {{count}} suggestion available',
    'search-autosuggest-len_plural':
      'There are {{count}} suggestions available',
    'search-current-suggestion': 'Current selection: {{selection}}',
    street: 'Street',
    subway: 'Metro',
    station: 'Station',
    stop: 'Stop',
    'stop-near-you': 'Search stops and routes',
    'stop-near-you-airplane': 'Search flights or airports',
    'stop-near-you-bus': 'Search bus routes or stops',
    'stop-near-you-citybike': 'Search city bike stations',
    'stop-near-you-rail': 'Search train routes or stations',
    'stop-near-you-subway': 'Search metro routes or stations ',
    'stop-near-you-tram': 'Search tram routes or stops',
    'stop-route-station': 'Bus and stop search',
    'today-at': 'today at',
    'tomorrow-at': 'tomorrow at',
    tram: 'Tram',
    track: 'Track',
    'use-own-position': 'Use current location',
    'select-from-map': 'Select position from map',
    'select-from-own-locations': 'Select from own locations',
    venue: 'Venue',
    'via-point': 'Via point',
    where: 'Where to?',
    place: 'Location',
  },
  fi: {
    address: 'Osoite',
    'address-place-or-business': 'Osoite, paikka tai yritys',
    'add-via-button-label': 'Lisää välipiste',
    'add-via-duration-button-label':
      'Aseta välipisteelle {{index}} pysähdyksen kesto',
    'add-via-duration-button-label-close':
      'Avaa välipisteen {{index}} pysähdyksen kesto valitsin',
    'add-via-duration-button-label-open':
      'Sulje välipisteen {{index}} pysähdyksen kesto valitsin',
    airplane: 'Lentokone',
    arrival: 'Perillä',
    back: 'Takaisin',
    vehiclerentalstation: 'Pyöräasema',
    bikepark: 'Liityntäpyöräparkki',
    bus: 'bussi',
    cancel: 'Peruuta',
    carpark: 'Liityntäpysäkointi',
    'clear-button-label': 'Tyhjennä',
    'clear-search-history': 'Tyhjennä hakuhistoria',
    currentposition: 'Tämänhetkinen sijainti',
    delete: 'Poista',
    'delete-old-searches-header': 'Haluatko tyhjentää hakuhistorian?',
    departure: 'Lähtöaika',
    destination: 'Määränpää',
    favourite: 'Suosikki',
    ferry: 'Lautta',
    'future-route': 'Tuleva reitti',
    'give-origin': 'Lähtöpaikka',
    'give-destination': 'Määränpää',
    origin: 'Lähtöpaikka',
    'origin-stop-near-you': 'Lähtöpaikka',
    ownlocations: 'Omat paikat',
    loading: 'Ladataan...',
    'minute-short': 'min',
    platform: 'Laituri',
    rail: 'Juna',
    required: 'pakollinen kenttä',
    search: 'Etsi',
    'search-address-or-place': 'Hae osoitteella tai paikan nimellä',
    'search-button-label': 'Hae',
    'search-destination': 'Hae määränpäätä, linjaa tai pysäkkiä',
    'search-destination-index': 'Syötä määränpää',
    'search-destination-results-but-no-search':
      'Katso tulokset viereiseltä Määränpää-välilehdeltä',
    'search-no-results': 'Ei tuloksia',
    'search-origin': 'Hae lähtöpaikkaa, linjaa tai pysäkkiä',
    'search-origin-index': 'Syötä lähtöpaikka',
    'search-autosuggest-label': 'Paikka, linja ja pysäkkihaku.',
    'search-autosuggest-label-instructions-desktop':
      'Navigoi listassa nuolinäppäimillä ja valitse enterillä.',
    'search-autosuggest-label-instructions-mobile':
      'Syötä sijainti ja navigoi listassa pyyhkäisemällä.',
    'search-autosuggest-label-move-to-destination':
      'Valittuasi lähtöpaikan siirrytään suoraan määränpää-kenttään.',
    'search-autosuggest-len': ' Löydettiin {{count}} ehdotus',
    'search-autosuggest-len_plural': ' Löydettiin {{count}} ehdotusta',
    'search-current-suggestion': 'Tämänhetkinen valinta: {{selection}}',
    'search-position': 'Paikanna',
    street: 'Katu',
    subway: 'Metro',
    station: 'Asema',
    stop: 'Pysäkki',
    'stop-near-you': 'Linja, pysäkki tai asema',
    'stop-near-you-airplane': 'Hae lentoja tai lentoasemaa',
    'stop-near-you-bus': 'Hae bussilinjaa tai pysäkkiä',
    'stop-near-you-citybike': 'Hae kaupunkipyöräasemaa',
    'stop-near-you-rail': 'Hae lähijunaa tai asemaa',
    'stop-near-you-subway': 'Hae metrolinjaa tai asemaa',
    'stop-near-you-tram': 'Hae raitiolinjaa tai pysäkkiä',
    'stop-route-station': 'Linja- ja pysäkkihaku',
    'today-at': 'tänään klo',
    'tomorrow-at': 'huomenna klo',
    tram: 'Raitiovaunu',
    track: 'Raide',
    'use-own-position': 'Käytä nykyistä sijaintia',
    'select-from-map': 'Valitse sijainti kartalta',
    'select-from-own-locations': 'Valitse omista paikoista',
    venue: 'Paikka',
    'via-point': 'Välipiste',
    where: 'Minne mennään?',
    place: 'Paikka',
  },
  pl: {
    address: 'Adres',
    'address-place-or-business': 'Adres, miejsce lub firma',
    'add-via-button-label': 'Dodaj punkt pośredni',
    'add-via-duration-button-label':
      'Wybierz czas postoju dla punktu {{index}}',
    'add-via-duration-button-label-close':
      'Zamknij wybornik czasu postoju w punkcie {{index}}',
    'add-via-duration-button-label-open':
      'Otwórz wybornik czasu postoju w punkcie {{index}}',
    airplane: 'Lot',
    arrival: 'Przyjazd',
    back: 'Wróć',
    bikepark: 'Parkuj i Jedź dla rowerów',
    bikerentalstation: 'Stacja rowerowa',
    bus: 'autobus',
    cancel: 'Anuluj',
    carpark: 'Parkuj i Jedź',
    'clear-button-label': 'Wyczyść',
    'clear-search-history': 'Wyczyść historię wyszukiwania',
    currentposition: 'Obecne położenie',
    delete: 'Usuń',
    'delete-old-searches-header':
      'Czy na pewno chcesz wyczyścić historię wyszukiwania?',
    departure: 'Odjazd',
    destination: 'Cel',
    'give-origin': 'Wprowadź swój punkt początkowy.',
    'give-destination': 'Wprowadź swój cel',
    favourite: 'Ulubione',
    ferry: 'Prom',
    'future-route': 'Przyszła trasa',
    origin: 'Początek',
    'origin-stop-near-you': 'Początek',
    ownlocations: 'Własne miejsca',
    loading: 'Ładowanie…',
    'minute-short': 'min.',
    platform: 'Peron',
    rail: 'Pociąg',
    required: 'wymagane pole',
    search: 'Szukaj',
    'search-address-or-place': 'Szukaj po adresie lub nazwie miejsca',
    'search-button-label': 'Szukaj',
    'search-destination': 'Szukaj celu, trasy lub przystanku',
    'search-destination-index': 'Wprowadź punkt docelowy',
    'search-destination-results-but-no-search':
      'Wyświetl wyniki w sąsiedniej karcie „Cel”',
    'search-no-results': 'Brak lokalizacji',
    'search-origin': 'Wyszukaj początek, koniec lub punkt pośredni',
    'search-origin-index': 'Wprowadź punkt początkowy',
    'search-position': 'Wykryj lokalizację',
    'search-autosuggest-label': 'Miejsce, lokalizacja i przystanek.',
    'search-autosuggest-label-instructions-desktop':
      'Nawiguj po liście używając strzałek i wybieraj klawiszem Enter.',
    'search-autosuggest-label-instructions-mobile':
      'Wprowadź lokalizację i nawiguj po liście gestami przesuwania.',
    'search-autosuggest-label-move-to-destination':
      'Po wybraniu lokalizacji początkowej, automatycznie przejdziesz do pola miejsca docelowego.',
    'search-autosuggest-len': 'Dostępna jest {{count}} propozycja',
    'search-autosuggest-len_few': 'Dostępne są {{count}} propozycje',
    'search-autosuggest-len_other': 'Dostępne jest {{count}} propozycji',
    'search-current-suggestion': 'Obecny wybór: {{selection}}',
    street: 'Ulica',
    subway: 'Metro',
    station: 'Stacja',
    stop: 'Przystanek',
    'stop-near-you': 'Szukaj przystanków i tras',
    'stop-near-you-airplane': 'Szukaj lotów i lotnisk',
    'stop-near-you-bus': 'Szukaj tras autobusowych i przystanków',
    'stop-near-you-citybike': 'Szukaj stacji rowerów miejskich',
    'stop-near-you-rail': 'Szukaj tras kolejowych i przystanków',
    'stop-near-you-subway': 'Szukaj tras metra i przystanków ',
    'stop-near-you-tram': 'Szukaj tras tramwajowych i przystanków',
    'stop-route-station': 'Wyszukiwanie autobusów i przystanków',
    'today-at': 'dziś o',
    'tomorrow-at': 'jutro o',
    tram: 'Tramwaj',
    track: 'Tor',
    'use-own-position': 'Użyj obecnej lokalizacji',
    'select-from-map': 'Wybierz miejsce na mapie',
    'select-from-own-locations': 'Wybierz z własnych miejsc',
    venue: 'Miejsce',
    'via-point': 'Przez punkt',
    where: 'Dokąd?',
    place: 'Miejsce',
  },
  sv: {
    address: 'Adress',
    'address-place-or-business': 'Adress, plats eller företag',
    'add-via-button-label': 'Lägg till viapunkt',
    'add-via-duration-button-label':
      'Ställ in varaktighet för viapunkten {{index}}',
    'add-via-duration-button-label-close':
      'Stäng väljaren för varaktighet vid via-punkten {{index}}',
    'add-via-duration-button-label-open':
      'Öppna väljaren för varaktighet vid via-punkten {{index}}',
    airplane: 'Flyg',
    arrival: 'Anländer',
    back: 'Tillbaka',
    bikerentalstation: 'Stadscykelstation',
    bikepark: 'Anslutningsparkering för cyklar',
    bus: 'Bussi',
    cancel: 'Avbryt',
    carpark: 'Infartsparkering',
    'clear-button-label': 'Töm',
    'clear-search-history': 'Töm sökhistoriken',
    currentposition: 'Nuvarande position',
    delete: 'Ta bort',
    'delete-old-searches-header': 'Vill du tömma sökhistoriken?',
    departure: 'Avgångstid',
    destination: 'Destination',
    favourite: 'Favorit',
    ferry: 'Färja',
    'future-route': 'Framtida rutt',
    'give-destination': 'Skriv in din destination',
    'give-origin': 'Skriv in din avfärdsplats',
    origin: 'Avfärdsplats',
    'origin-stop-near-you': 'Avfärdsplats',
    ownlocations: 'Egna platser',
    loading: 'Laddar...',
    'minute-short': 'min',
    platform: 'Plattform',
    rail: 'Tåg',
    required: 'obligatoriskt fält',
    search: 'Sök',
    'search-address-or-place': 'Sök med adressen eller platsens namn',
    'search-button-label': 'Sök',
    'search-destination': 'Sök destination, linje eller hållplats',
    'search-destination-index': 'Skriv destination',
    'search-destination-results-but-no-search':
      'Se resultaten under fliken Destination',
    'search-no-results': 'Inga sökresultat',
    'search-origin': 'Sök avfärdsplats, linje eller hållplats',
    'search-origin-index': 'Skriv avfärdsplats',
    'search-position': 'Sök position',
    'search-autosuggest-label': 'Plats, linje och hållplatssökning.',
    'search-autosuggest-label-instructions-desktop':
      'Navigera listan med piltangenterna och välj med Enter-tangeten.',
    'search-autosuggest-label-instructions-mobile':
      'Ange platsen och navigera i listan genom att svepa.',
    'search-autosuggest-label-move-to-destination':
      'Efter att du valt avgångsplatsen tas du direkt till Destination-fältet.',
    'search-autosuggest-len': 'Hittade {{count}} förslag',
    'search-current-suggestion': 'Nuvarande val: {{selection}}',
    street: 'Gata',
    subway: 'Metro',
    station: 'Station',
    stop: 'Hållplats',
    'stop-near-you': 'Sök hållplatser eller linjer',
    'stop-near-you-airplane': 'Sök flyg eller flygplatser',
    'stop-near-you-bus': 'Sök busslinjer eller hållplatser',
    'stop-near-you-citybike': 'Sök stadscykelstationer',
    'stop-near-you-rail': 'Sök närtåger eller stationer',
    'stop-near-you-subway': 'Sök metrolinjer eller stationer',
    'stop-near-you-tram': 'Sök spårvagnlinjer eller hållplatser',
    'stop-route-station': 'Buss och stopp sökningen',
    'today-at': 'i dag kl',
    'tomorrow-at': 'i morgon',
    tram: 'Spårvagn',
    track: 'Spår',
    'use-own-position': 'Använd min position',
    'select-from-map': 'Välj position från kartan',
    'select-from-own-locations': 'Välj från egna platser',
    venue: 'Mötesplats',
    'via-point': 'Via punkt',
    where: 'Vart vill du åka?',
    place: 'Plats',
  },
};

export default translations;
